// src/components/PremiumSuccess/index.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import PremiumSuccessDesktop from "./PremiumSuccessDesktop";
import PremiumSuccessMobile from "./PremiumSuccessMobile";

export default function PremiumSuccess() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <PremiumSuccessMobile /> : <PremiumSuccessDesktop />;
}
